import { render, staticRenderFns } from "./TgLogo.vue?vue&type=template&id=fe1a4080&scoped=true"
import script from "./TgLogo.vue?vue&type=script&lang=js"
export * from "./TgLogo.vue?vue&type=script&lang=js"
import style0 from "./TgLogo.vue?vue&type=style&index=0&id=fe1a4080&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1a4080",
  null
  
)

export default component.exports